import './AddItm.css'

function AddItm({ titulo, anadiritm }) {
    return (
        <button className="icon-btn add-btn" onClick={() => anadiritm(undefined)}>
            <div className="add-icon"></div>
            <div className="btn-txt">Nuevo {titulo}</div>
        </button>
    );
}

export default AddItm;
